'use client'

import { Button } from '@snowball-tech/fractal/dist/src/components/Button'
import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'
import {
  UilCommentsAlt as CoachingsIcon,
  UilBookOpen as MediaIcon,
  UilBookReader as SubscriptionsIcon,
} from '@tooni/iconscout-unicons-react'

import isEmpty from 'lodash/fp/isEmpty'

import { getAppUrlInfo } from '../../helpers'
import {
  getArticlesUrl,
  getPricingPage,
  getSnowballMaxPage,
  getURLs,
  usePathname,
} from '../../helpers/navigation'
import useFeatureFlags from '../../hooks/useFeatureFlags'
import useTranslations from '../../hooks/useTranslations'
import RouterButton from '../RouterButton'

type Props = {
  desktopWithIcon?: boolean
  mobile?: boolean
  mobileWithIcon?: boolean
  onClick?: () => void
}
export default function TopMenu({
  desktopWithIcon = false,
  mobile = false,
  mobileWithIcon = true,
  onClick,
}: Props) {
  const pathname = usePathname()
  const $t = useTranslations()

  const { appName } = getAppUrlInfo()
  const URLs = getURLs()

  const { allowMaxSignups } = useFeatureFlags()

  const links = [
    {
      href: getArticlesUrl(),
      icon: <MediaIcon />,
      labelTranslationKey: 'header.newsletters',
    },
    allowMaxSignups
      ? {
          href: getSnowballMaxPage(undefined, 'header'),
          icon: <CoachingsIcon />,
          labelTranslationKey: 'header.coaching',
        }
      : undefined,
    {
      href: getPricingPage(),
      icon: <SubscriptionsIcon />,
      labelTranslationKey: 'header.plans_short',
    },
  ].filter((link) => !isEmpty(link))

  const mediaUrl = appName === 'media' ? '' : URLs.media

  return mobile ? (
    <div className="flex size-full flex-col gap-8">
      <div className="flex flex-1 flex-col gap-3">
        {links.map(({ href, icon, labelTranslationKey }) => (
          <RouterButton
            key={labelTranslationKey}
            className="group"
            href={`${mediaUrl}${href}`}
            icon={mobileWithIcon ? icon : undefined}
            iconPosition="left"
            underlined={false}
            variant="text"
            onClick={onClick}
          >
            <Typography
              className="overflow-hidden text-left group-hover:font-weight-median"
              variant={
                pathname === href.split('#').slice(0, -1).join('')
                  ? 'body-1-median'
                  : 'body-1'
              }
            >
              {$t(labelTranslationKey)}
            </Typography>
          </RouterButton>
        ))}
      </div>
      <div className="flex flex-col gap-3">
        <Button
          fullWidth
          href={`${mediaUrl}/signup`}
          label={$t('header.signup.label')}
          variant="display"
          onClick={onClick}
        />

        <Button
          fullWidth
          href={`${mediaUrl}/signin`}
          label={$t('general.signin')}
          onClick={onClick}
        />
      </div>
    </div>
  ) : (
    <div className="flex flex-row justify-center gap-5">
      {links.map(({ href, icon, labelTranslationKey }) => (
        <RouterButton
          key={labelTranslationKey}
          href={`${mediaUrl}${href}`}
          icon={desktopWithIcon ? icon : undefined}
          iconPosition="left"
          label={$t(labelTranslationKey)}
          underlined={false}
          variant="text"
          onClick={onClick}
        />
      ))}
    </div>
  )
}
